import { Middleware } from 'redux';
interface PersistConfig {
  key: string;
  blacklist: string[];
}
const persistMiddleware =
  (persistConfig: PersistConfig): Middleware =>
  (store) =>
  (next) =>
  (action) => {
    const result = next(action);
    const state = store?.getState();
    const keyPersist = persistConfig.key || 'persist';
    const blacklistPersist = persistConfig.blacklist || [];
    const stateToPersist = { ...state };
    blacklistPersist.forEach((key) => {
      delete stateToPersist[key];
    });
    localStorage.setItem(keyPersist, JSON.stringify(stateToPersist));
    return result;
  };
export default persistMiddleware;
